(function () {
  if (document.documentElement.dataset.zenMainCartScriptLoaded === 'true') return;

  document.documentElement.dataset.zenMainCartScriptLoaded = 'true';

  var cartSelector = '.zen-cart';

  function getCarts(container) {
    var root = container || document;
    var carts = [];

    if (root.matches && root.matches(cartSelector)) carts.push(root);

    return carts.concat(Array.prototype.slice.call(root.querySelectorAll(cartSelector)));
  }

  function destroyCart(cart) {
    if (typeof cart.zenMainCartCleanup === 'function') {
      cart.zenMainCartCleanup();
    }
  }

  function initializeCart(cart) {
    if (cart.dataset.zenMainCartInitialized === 'true') return;

    var cleanupCallbacks = [];

    function addListener(element, eventName, callback) {
      element.addEventListener(eventName, callback);
      cleanupCallbacks.push(function () {
        element.removeEventListener(eventName, callback);
      });
    }

    cart.querySelectorAll('.zen-cart-qty').forEach(function (qty) {
      var input = qty.querySelector('[data-zen-cart-input]');
      var minus = qty.querySelector('[data-zen-cart-minus]');
      var plus = qty.querySelector('[data-zen-cart-plus]');

      if (!input || !minus || !plus) return;

      function decreaseQuantity() {
        var value = parseInt(input.value || '0', 10);
        input.value = Math.max(0, value - 1);
      }

      function increaseQuantity() {
        var value = parseInt(input.value || '0', 10);
        input.value = value + 1;
      }

      addListener(minus, 'click', decreaseQuantity);
      addListener(plus, 'click', increaseQuantity);
    });

    cart.querySelectorAll('[data-zen-cart-remove]').forEach(function (removeLink) {
      function setCartError(message) {
        var errorTarget = cart.querySelector('#cart-errors');
        if (errorTarget) errorTarget.textContent = message || window.cartStrings?.error || '';
      }

      async function removeItem(event) {
        var line = parseInt(removeLink.getAttribute('data-zen-cart-line') || '0', 10);

        if (!line || typeof fetch !== 'function') return;

        event.preventDefault();
        setCartError('');
        removeLink.setAttribute('aria-disabled', 'true');
        removeLink.classList.add('is-loading');

        try {
          var response = await fetch(window.routes.cart_change_url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              line: line,
              quantity: 0,
            }),
          });

          if (!response.ok) throw new Error('Cart remove failed');

          window.location.href = window.routes.cart_url;
        } catch (error) {
          removeLink.removeAttribute('aria-disabled');
          removeLink.classList.remove('is-loading');
          setCartError(window.cartStrings?.error || 'A kosár frissítése most nem sikerült. Kérlek, próbáld újra.');
        }
      }

      addListener(removeLink, 'click', removeItem);
    });

    cart.dataset.zenMainCartInitialized = 'true';
    cart.zenMainCartCleanup = function () {
      cleanupCallbacks.forEach(function (cleanup) {
        cleanup();
      });
      delete cart.dataset.zenMainCartInitialized;
      delete cart.zenMainCartCleanup;
    };
  }

  function initializeCarts(container) {
    getCarts(container).forEach(initializeCart);
  }

  function destroyCarts(container) {
    getCarts(container).forEach(destroyCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeCarts(document);
    });
  } else {
    initializeCarts(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeCarts(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyCarts(event.target);
  });
})();
